var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_Promise.js
// module id = 1630
// module chunks = 3 9 13